import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { Search } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';

import { Storage } from '../../../utils/Storage';
import AuthService from '../../../services/auth.service';
import { getDeviceBySerialNumber } from '../../../services/device.service';

import './Visits.scss';

const Visits = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  const [notPairedMessage, setNotPairedMessage] = useState<string | null>(null);

  const isExternalUser = AuthService.getStoredUserProfile()?.isInternal === false;

  useEffect(() => {
    const lastVisit = Storage.getLastVisitId();
    if (lastVisit) {
      navigate(`/visits/${lastVisit.id}${lastVisit.bySerial ? '?bySerial=true' : ''}`, { replace: true });
    }
  }, [navigate]);

  const search = async () => {
    const value = searchValue.trim();
    if (!value) return;

    if (isExternalUser) {
      try {
        const result = await getDeviceBySerialNumber(value);
        if (result.results.at(0)) {
          navigate(`/visits/${value}?bySerial=true`);
          return;
        }
      } catch (err) {
        console.error('Serial number lookup failed:', err);
      }
    }

    navigate(`/search/${value}`);
  };

  return (
    <Box className='visits-screen'>
      <Box className='visits-search-panel'>
        <h1 className='visits-title'>Visits</h1>
        <TextField
          className='visits-search-field'
          value={searchValue}
          size='small'
          placeholder='Search with Device ID or Serial Number...'
          onChange={(event) => {
            setSearchValue(event.target.value);
            if (notPairedMessage) setNotPairedMessage(null);
          }}
          onKeyUp={(event) => {
            if (event.key === 'Enter') search();
          }}
          error={!!notPairedMessage}
          helperText={notPairedMessage ?? ''}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton className='visits-search-button' onClick={search} aria-label='Search visits'>
                  <Search sx={{ fontSize: 20 }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Box>
  );
};

export default Visits;
